import { useAuth } from '@/hooks/use-auth';
import { ProfileSection } from '@/components/settings/profile-section';
import { EveContextSection } from '@/components/settings/eve-context-section';
import { NotificationsSection } from '@/components/settings/notifications-section';
import { PasswordSection } from '@/components/settings/password-section';
import { DangerSection } from '@/components/settings/danger-section';

export function SettingsPage() {
  const { profile, reloadProfile, isOwner } = useAuth();
  if (!profile) return null;
  return (
    <div className="mx-auto max-w-2xl space-y-6 p-6">
      <header>
        <h1 className="text-xl font-semibold text-slate-100">Einstellungen</h1>
        <p className="text-sm text-slate-400">{profile.email}</p>
      </header>
      <ProfileSection
        name={typeof profile.name === 'string' ? profile.name : ''}
        nickname={profile.nickname}
        avatarUrl={typeof profile.avatar_url === 'string' ? profile.avatar_url : ''}
        onSaved={() => void reloadProfile()}
      />
      <EveContextSection isOwner={isOwner} />
      <NotificationsSection />
      <PasswordSection />
      {!isOwner ? <DangerSection /> : null}
    </div>
  );
}
